import Edit from "./Edit";
import New from "./New";

export default function Modal(props) {
    return props.view === 'form' ?
        (props.project ?
            <Edit project={props.project} close={props.close} />:
            <New close={props.close} submitted={props.setView}/>):
        <button onClick={() => {props.setView()}} title="Add project"><i className="las la-plus-square"></i></button>
}